
export default {
    Ready : "ready",
    Loading : "loading",
    Success : "success",
    Error   : "error"
}
